import { useQuery } from '@tanstack/react-query';
import { useAppConstantsContext } from '@/context/AppConstants';

export async function getMrRogersNpanxx(
  npanxx: string,
  mrRogersAPIKey: string
) {
  const url = `/ss/mrg/v1/npanxx?key=${mrRogersAPIKey}&npanxx=${npanxx}`;
  const response = await fetch(url);
  if (response.ok) {
    return response.json();
  }
  throw new Error('Error fetching NPANXX data');
}

export default function useMrRogersNpanxx({
  phoneNumber,
}: {
  phoneNumber: string;
}) {
  const {
    keys: { mrRogersAPIKey },
  } = useAppConstantsContext();
  const npanxx = phoneNumber.replace(/\D/g, '').slice(0, 6);

  return useQuery({
    queryKey: ['MrRogersPhoneLocation', phoneNumber],
    queryFn: () => getMrRogersNpanxx(npanxx, mrRogersAPIKey),

    enabled: !!phoneNumber,
  });
}
